// GENERATED FILE, PLEASE DO NOT EDIT
export var BannerHighlightBackground = '#f4f6fe';
export var BannerHighlightIcon = '#2a4de4';
export var ButtonFlatPrimaryForeground = '#4969f5';
export var ButtonFlatPrimaryForegroundHovered = '#2a4de4';
export var ButtonFlatPrimaryForegroundPressed = '#1537c7';
export var ButtonFlatSecondaryForeground = '#4969f5';
export var ButtonFlatSecondaryForegroundHovered = '#2a4de4';
export var ButtonFlatSecondaryForegroundPressed = '#1537c7';
export var ButtonPrimaryBackground = '#4969f5';
export var ButtonPrimaryBackgroundHovered = '#2a4de4';
export var ButtonPrimaryBackgroundPressed = '#1537c7';
export var ButtonPrimaryToggleBackground = '#f4f6fe';
export var ButtonPrimaryToggleBackgroundDisabled = '#fafbff';
export var ButtonPrimaryToggleBackgroundHovered = '#e6ebfd';
export var ButtonPrimaryToggleBackgroundPressed = '#d1dafb';
export var ButtonPrimaryToggleBackgroundOff = '#ffffff';
export var ButtonPrimaryToggleBackgroundOffDisabled = '#ffffff';
export var ButtonPrimaryToggleBackgroundOffPressed = '#D6D6D6';
export var ButtonPrimaryToggleBorderOff = '#D6D6D6';
export var ButtonPrimaryToggleBorderOffHovered = '#D6D6D6';
export var ButtonPrimaryToggleBorderOffPressed = '#D6D6D6';
export var ButtonPrimaryToggleBorderOn = '#91a5f9';
export var ButtonPrimaryToggleBorderOnDisabled = '#e6ebfd';
export var ButtonPrimaryToggleBorderOnHovered = '#91a5f9';
export var ButtonPrimaryToggleBorderOnPressed = '#91a5f9';
export var ButtonPrimaryToggleForeground = '#2a4de4';
export var ButtonPrimaryToggleForegroundDisabled = '#b4c2fa';
export var ButtonPrimaryToggleForegroundHovered = '#2a4de4';
export var ButtonPrimaryToggleForegroundPressed = '#2a4de4';
export var ButtonSecondaryBackground = '#f4f6fe';
export var ButtonSecondaryBackgroundHovered = '#e6ebfd';
export var ButtonSecondaryBackgroundPressed = '#d1dafb';
export var ButtonSecondaryForeground = '#2a4de4';
export var ButtonSecondaryForegroundHovered = '#2a4de4';
export var ButtonSecondaryForegroundPressed = '#2a4de4';
export var ButtonSecondaryToggleBackground = '#f4f6fe';
export var ButtonSecondaryToggleBackgroundDisabled = '#fafbff';
export var ButtonSecondaryToggleBackgroundHovered = '#e6ebfd';
export var ButtonSecondaryToggleBackgroundPressed = '#d1dafb';
export var ButtonSecondaryToggleBackgroundOff = '#ffffff';
export var ButtonSecondaryToggleBackgroundOffDisabled = '#ffffff';
export var ButtonSecondaryToggleBackgroundOffPressed = '#E7E7E7';
export var ButtonSecondaryToggleBorderOff = '#D6D6D6';
export var ButtonSecondaryToggleBorderOffHovered = '#D6D6D6';
export var ButtonSecondaryToggleBorderOn = '#91a5f9';
export var ButtonSecondaryToggleBorderOnDisabled = '#e6ebfd';
export var ButtonSecondaryToggleBorderOnHovered = '#91a5f9';
export var ButtonSecondaryToggleBorderOnPressed = '#91a5f9';
export var ButtonSecondaryToggleForeground = '#2a4de4';
export var ButtonSecondaryToggleForegroundDisabled = '#b4c2fa';
export var ButtonSecondaryToggleForegroundHovered = '#2a4de4';
export var ButtonSecondaryToggleForegroundPressed = '#2a4de4';
export var ButtonTertiaryToggleBackground = '#ffffff';
export var ButtonTertiaryToggleBackgroundDisabled = '#ffffff';
export var ButtonTertiaryToggleBackgroundHovered = '#ffffff';
export var ButtonTertiaryToggleBackgroundPressed = '#ffffff';
export var ButtonTertiaryToggleBackgroundOff = '#E7E7E7';
export var ButtonTertiaryToggleBackgroundOffDisabled = '#F7F7F7';
export var ButtonTertiaryToggleBackgroundOffHovered = '#D6D6D6';
export var ButtonTertiaryToggleBackgroundOffPressed = '#D6D6D6';
export var ButtonTertiaryToggleBorderOn = '#E7E7E7';
export var ButtonTertiaryToggleBorderOnDisabled = '#F7F7F7';
export var ButtonTertiaryToggleBorderOnHovered = '#E7E7E7';
export var ButtonTertiaryToggleBorderOnPressed = '#E7E7E7';
export var ButtonTertiaryToggleBorderOff = '#E7E7E7';
export var ButtonTertiaryToggleBorderOffDisabled = '#F7F7F7';
export var ButtonTertiaryToggleBorderOffHovered = '#D6D6D6';
export var ButtonTertiaryToggleBorderOffPressed = '#D6D6D6';
export var ButtonTertiaryToggleForeground = '#4969f5';
export var ButtonTertiaryToggleForegroundDisabled = '#b4c2fa';
export var ButtonTertiaryToggleForegroundHovered = '#4969f5';
export var ButtonTertiaryToggleForegroundPressed = '#4969f5';
export var ButtonTertiaryToggleForegroundOff = '#191919';
export var ButtonTertiaryToggleForegroundOffDisabled = '#B2B2B2';
export var ButtonTertiaryToggleForegroundOffHovered = '#191919';
export var ButtonTertiaryToggleForegroundOffPressed = '#191919';
export var FieldsBackgroundActive = '#ffffff';
export var FieldsBackgroundInactive = '#ffffff';
export var FieldsBorderActive = '#91a5f9';
export var FieldsBorderDisabled = '#D6D6D6';
export var FieldsBorderInactive = '#D6D6D6';
export var ListCellIconToggledOn = '#4969f5';
export var LoadingDefault = '#4969f5';
export var OverlayLoadingDefault = '#4969f5';
export var PaginationNumberedSelectedBackground = '#f4f6fe';
export var PaginationNumberedSelectedBackgroundDisabled = '#fafbff';
export var PaginationNumberedSelectedBackgroundHovered = '#e6ebfd';
export var PaginationNumberedSelectedBackgroundPressed = '#d1dafb';
export var PaginationNumberedSelectedBorder = '#91a5f9';
export var PaginationNumberedSelectedBorderDisabled = '#e6ebfd';
export var PaginationNumberedSelectedBorderHovered = '#91a5f9';
export var PaginationNumberedSelectedBorderPressed = '#91a5f9';
export var PaginationNumberedSelectedForeground = '#2a4de4';
export var PaginationNumberedSelectedForegroundDisabled = '#B2B2B2';
export var PaginationNumberedSelectedForegroundHovered = '#2a4de4';
export var PaginationNumberedSelectedForegroundPressed = '#2a4de4';
export var PaginationNumberedUnselectedBackground = '#ffffff';
export var PaginationNumberedUnselectedBackgroundDisabled = '#ffffff';
export var PaginationNumberedUnselectedBackgroundHovered = '#D6D6D6';
export var PaginationNumberedUnselectedBackgroundPressed = '#E7E7E7';
export var PaginationNumberedUnselectedBorderHovered = '#D6D6D6';
export var PaginationSelectedPrimary = '#4969f5';
export var RatingSelected = '#4969f5';
export var SliderKnobBackground = '#4969f5';
export var SliderKnobBackgroundHovered = '#2a4de4';
export var SliderKnobBackgroundPressed = '#1537c7';
export var SliderTrackBackgroundOn = '#4969f5';
export var TagHighlightBackground = '#4969f5';
export var TagHighlightDefaultBackground = '#e6ebfd';
export var TagHighlightDefaultForeground = '#2a4de4';
export var TagHighlightDefaultIcon = '#2a4de4';
export var TagHighlightEmphasisBackground = '#4969f5';
export var TextAction = '#4969f5';
export var TextCallout = '#4969f5';
export var TextHighlight = '#4969f5';
export var TextSelected = '#4969f5';
export var ToggleBackgroundOn = '#4969f5';
export var ToggleBorderOn = '#4969f5';
export var TooltipHighlightBackground = '#4969f5';
export var TooltipHighlightBackgroundHovered = '#2a4de4';
export var TooltipHighlightBackgroundPressed = '#1537c7';